import { bannerStore } from '../stores';
import { studentAppModalStore } from '../stores/studentAppModalStore';
import {
  getThemeColor,
  getThemeColor2,
  getContrastingThemeColor,
} from '../types';

import { useLayout } from './useLayout';
import { usePracticeLockStatus } from './usePracticeLockStatus';
import { useProcessedProblems } from './useProcessedProblems';
import { useProcessedWorkStore } from './useProcessedWorkStore';

interface bannerStore {
  showGamesMenu: boolean;
  showDisabledGamesMenu: boolean;
  isShowHand: boolean;
  themeColor: string;
  themeColor2: string;
  contrastingThemeColor: string;
  showSquares: boolean;
}

export const useProcessedBannerStore = (): bannerStore => {
  const [
    gameCredits,
    blockGames,
    blockGamesClass,
    userChoiceForShowSquares,
  ] = bannerStore(state => [
    state.gameCredits,
    state.blockGames,
    state.blockGamesClass,
    state.userChoiceForShowSquares,
  ]);
  const [games] = studentAppModalStore(state => [state.availableGames]);
  const [isAllowHand, teacherOnline, themeOption] = bannerStore(state => [
    state.allowHand,
    state.teacherOnline,
    state.themeOption,
  ]);
  const { currentWorkType } = useProcessedWorkStore();
  const { currentProblem } = useProcessedProblems();
  const practiceLocked = usePracticeLockStatus();
  const { isLandscape } = useLayout();

  const showSquares =
    userChoiceForShowSquares !== undefined
      ? userChoiceForShowSquares
      : isLandscape;

  const showGamesMenu =
    !!gameCredits &&
    games.length > 0 &&
    !blockGames &&
    !blockGamesClass &&
    !practiceLocked;

  const showDisabledGamesMenu =
    games.length > 0 && !gameCredits && !practiceLocked;

  const isShowHand =
    !!currentProblem &&
    isAllowHand &&
    teacherOnline &&
    currentWorkType !== 'EXAM' &&
    currentWorkType !== 'NONE';

  const themeColor = getThemeColor(themeOption);

  const themeColor2 = getThemeColor2(themeOption);

  const contrastingThemeColor = getContrastingThemeColor(themeOption);

  return {
    showGamesMenu,
    showDisabledGamesMenu,
    isShowHand,
    themeColor,
    themeColor2,
    contrastingThemeColor,
    showSquares,
  };
};
